import React from 'react'
import searchViewMap from "../Index";
import DocDynamicGroupTree from './DocDynamicGroupTree';

const DocSearchResult = (props) => {
    const { viewData, onSearchRequest, dynamicGroupManager,
        reloadSearch, rowSelector, deviceInfo,
        recalculateParameters, setRecalculateParameters } = props

    // console.log ("device info s", deviceInfo);
        
    const renderDynamicGroupChoice = () => {
        return (
            <DocDynamicGroupTree 
                dynamicGroupManager={dynamicGroupManager} 
                deviceInfo={deviceInfo}
                stickyTop={props.stickyTop}
            />
        )
    }

    const renderResultView = (hasDynamicGroup, viewKey) => {
        let DynamicContainer = searchViewMap[viewKey];

        if(!DynamicContainer) {
            DynamicContainer = searchViewMap["vCMNSearchTableGrid"];
        }

        if(!DynamicContainer) {
            return null;
        }
        else if(hasDynamicGroup) {
            return (
                <div className="uiResultViewColumn">
                    <DynamicContainer 
                        viewData={viewData.childViews.resultView} 
                        onSearchRequest={onSearchRequest} 
                        stickyTop={props.stickyTop}
                        rowSelector={rowSelector} 
                        reloadSearch={reloadSearch}
                        deviceInfo={deviceInfo}
                        recalculateParameters={recalculateParameters} 
                        setRecalculateParameters={setRecalculateParameters}
                    />
                </div>
            )
        }
        else {
            return (
                <DynamicContainer 
                    viewData={viewData.childViews.resultView} 
                    onSearchRequest={onSearchRequest} 
                    stickyTop={props.stickyTop}
                    rowSelector={rowSelector} 
                    reloadSearch={reloadSearch}
                    deviceInfo={deviceInfo}
                    recalculateParameters={recalculateParameters} 
                    setRecalculateParameters={setRecalculateParameters}
                />
            )
        }
    }

    const hasDynamicGroup = dynamicGroupManager.hasDynamicGroupSelection;
  
    if(!viewData || !viewData.masterKeys || !viewData.childViews.resultView) {
        return null;
    }
    else if(hasDynamicGroup) {
        return (
            <div className='uiDocSearchLayout uiTwoColumn'>
                {renderDynamicGroupChoice()}
                {renderResultView(hasDynamicGroup, viewData.childViews.resultView.viewKey)}
            </div>
        )
    }
    else {
        return (
            <div className='uiDocSearchLayout uiOneColumn'>
                {renderResultView(hasDynamicGroup, viewData.childViews.resultView.viewKey)}
            </div>
        )
    }
}

export default DocSearchResult